/**
 * @module Template - Default
 * @description Default Template
 */
import Header from "@/blocks/Header";
import Footer from "@/blocks/Footer";

// Content Provider
import useContentProviderLegal from "@/providers/content-provider/hooks/useContentProviderLegal";

/**
 * @function Template
 * @description
 */
const Template = ({ title, stickyBanner, hero, primary, modal }) => {
  const [ref] = useContentProviderLegal();
  return (
    <>
      <Header />

      <div ref={ref} id="primary" className="content-area">
        <main id="content" className="site-content" role="main" tabIndex="-1">
          <article id="post-id" className="hentry entry page-entry">
            {stickyBanner}
            <header className="entry-header" suppressHydrationWarning={true}>
              <h1 className="entry-title screen-reader-text">{title}</h1>
              <div id="js-hero-container">{hero}</div>
            </header>

            <div className="entry-content" suppressHydrationWarning={true}>
              {primary}
            </div>
          </article>
        </main>

        {modal}
      </div>
      {/* <!-- .content-area --> */}

      <Footer />
    </>
  );
};

export default Template;
